import {cx} from "emotion";
import * as React from "react";

import "./picker-panel.scss";

import {cs}             from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {Calendar}       from "@Common/ui-components/calendar/calendar/calendar";
import {MonthYearPanel} from "@Common/ui-components/calendar/month-year-panel/month-year-panel";
import * as dateObj     from "@Common/utils/date-object";

import {SelectedDateHeader} from "./selected-date-header/selected-date-header";
import {Types} from "@Common/types";

export const PickerPanel = ({
    domRef,
    endDate,
    focus,
    maxDate,
    minDate,
    onClear,
    onClose,
    position,
    startDate,
}:{
    domRef    : React.Ref<HTMLDivElement>,
    endDate   : Pick<Types.Common.React.UseState.UseStateNext<Types.Common.Utils.DateObject.DateObject>, "onChange" | "value">,
    focus     : Types.Common.React.UseState.UseStateNext<"start" | "end">,
    maxDate   : Types.Common.Utils.DateObject.DateObject,
    minDate   : Types.Common.Utils.DateObject.DateObject,
    onClear   : () => void,
    onClose   : () => void,
    position  : React.CSSProperties,
    startDate : Pick<Types.Common.React.UseState.UseStateNext<Types.Common.Utils.DateObject.DateObject>, "onChange" | "value">,
}) => cs(
    ["monthYear", (_, next) => UseState({
        next,
        initValue: {
            month: new Date().getMonth() + 1,
            year : new Date().getFullYear(),
        }
    })],
    ({monthYear}) => (
        <div className="picker-panel-zx1" ref={domRef} style={position}>
            <div className="top">
                {SelectedDateHeader({
                    startDate, endDate,
                })}
                {MonthYearPanel({
                    minMonthYear: {year: minDate.year, month: minDate.month},
                    maxMonthYear: {year: maxDate.year, month: maxDate.month},
                    monthYear,
                })}

                {Calendar({
                    startDate: startDate.value, endDate: endDate.value,
                    monthYear: monthYear.value,
                    onSelect: (date:Types.Common.Utils.DateObject.DateObject) => {
                        if (focus.value === "start") {
                            if (endDate.value != null && dateObj.gt(date, endDate.value)) {
                                endDate.onChange(date);
                            } else {
                                startDate.onChange(date);
                                focus.onChange("end");
                            }
                        } else {
                            if (startDate.value != null && dateObj.lt(date, startDate.value)) {
                                startDate.onChange(date);
                            } else {
                                endDate.onChange(date);
                                focus.onChange("start");
                            }
                        }
                    },
                    isDisabled: (date:Types.Common.Utils.DateObject.DateObject) => dateObj.lt(date, minDate) || dateObj.gt(date, maxDate),
                })}
            </div>
            <div className="bottom">
                <div className="clear-cancel">
                    <button
                        className="clear"
                        onClick={onClear}
                        xd-qa-type="button"
                        xd-qa-name="picker-clear"
                    >
                        Clear
                    </button>
                </div>
                <button
                    className={cx("close", {})}
                    onClick={onClose}
                    xd-qa-type="button"
                    xd-qa-name="picker-close"
                >
                    Close
                </button>
            </div>
        </div>
    ),
);
